import { render } from "./NewUserView.vue?vue&type=template&id=1752ed48&scoped=true"
import script from "./NewUserView.vue?vue&type=script&lang=js"
export * from "./NewUserView.vue?vue&type=script&lang=js"

import "./NewUserView.vue?vue&type=style&index=0&id=1752ed48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1752ed48"]])

export default __exports__